import React from 'react';

const BatteryStatus = ({battery, style}) => {
    const item_class_name = style.item_class_name || 'md-status-bar-item';

    if (!battery) {
        return null;
    }

    let icon = 'fa-battery';
    let color_class = 'c-green';

    if(battery < 24) {
        icon = icon + '-1';
        color_class = 'c-red';
    } else if (battery >= 24 && battery <= 50) {
        icon = icon + '-2';
        color_class = 'c-orange';
    } else if (battery > 50 && battery <= 94) {
        icon = icon + '-3';
        color_class = 'c-yellow';
    }

    return (
        <div className={`${color_class} ${item_class_name}`}>
            <i className={`fa ${icon}`}></i> {battery || '--'}%
        </div>
    );

}

BatteryStatus.defaultProps = {
    battery: null,
    style: {},
};

export default BatteryStatus;



// WEBPACK FOOTER //
// ./src/components/Status/Battery.js